import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireApproved = true, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    if (requireAdmin && user.role !== "admin") {
      navigate("/dashboard", { replace: true });
    }
  }, [loading, user, requireAdmin, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-parchment">
        <div className="overline">Loading…</div>
      </div>
    );
  }
  if (!user) return null;
  if (requireApproved && user.status !== "approved" && user.role !== "admin") {
    return <PendingScreen user={user} />;
  }
  return children;
}

function PendingScreen({ user }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const rejected = user.status === "rejected";
  return (
    <div className="min-h-screen bg-parchment flex items-center justify-center px-6" data-testid="pending-screen">
      <div className="max-w-lg w-full border border-line bg-parchment2 p-10">
        <div className="overline">{rejected ? "Access denied" : "Account under review"}</div>
        <h1 className="h-serif text-4xl text-ink mt-4 leading-tight">
          {rejected
            ? "Your intake was not approved."
            : "Thank you. Your intake is being reviewed."}
        </h1>
        <p className="text-sub mt-5 leading-relaxed">
          {rejected
            ? "Our analysts were unable to clear this account against our compliance framework. If you believe this is in error, write to intake@campbellscommoditiesbrokeragellc.com from a corporate domain."
            : "An analyst is verifying your corporate identity. You will be notified by email when the platform unlocks — typically within 24 business hours. The dashboard, pricing tiers and RFQ engine remain sealed until approval."}
        </p>
        <div className="mt-8 flex gap-3">
          <button
            onClick={async () => { await logout(); navigate("/"); }}
            className="btn-ghost"
            data-testid="pending-signout"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
